import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Help(props) {
  var cssClass = classNames('tds-form__help', props.classNames, {
    'tds-form__help--emphasised': props.emphasised,
    'tds-form__help--segment': props.isSegment,
    'tds-form__help--alternative': props.alternative
  });
  return props.children ? /*#__PURE__*/React.createElement("div", {
    className: cssClass
  }, props.children) : /*#__PURE__*/React.createElement("span", null);
}

Help.propTypes = {
  classNames: PropTypes.string,
  emphasised: PropTypes.bool,
  isSegment: PropTypes.bool,
  alternative: PropTypes.bool,
  children: PropTypes.node
};
Help.defaultProps = {
  emphasised: false,
  isSegment: false,
  alternative: false,
  classNames: '',
  children: null
};
export default Help;